<template>
  <div class="flex flex-col">
    <SkeletonLoader
      width="100%"
      height="28px"
      class="h-14 lg:h-7 mt-7 w-2/3 lg:w-auto"
    />
    <SkeletonLoader
      width="100%"
      height="48px"
      class="h-[72px] lg:h-12 w-2/3 mt-4 lg:w-auto"
    />
    <NewsletterFormInputsSkeleton :footer-newsletter="true" />
    <SkeletonLoader
      width="100%"
      height="50px"
      class="h-[74px] lg:h-[50px] mt-7 w-2/3 lg:w-auto"
    />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'FooterNewsletterFormSkeleton',

});

</script>
